import React from 'react';
import { X } from 'lucide-react';
import clsx from 'clsx';
import styles from './CloseButton.module.css';

interface CloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
  size?: number;
  className?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, disabled = false, size = 20, className = '' }) => {
  return (
    <button
      type="button"
      className={clsx(styles.closeButton, className)}
      onClick={onClick}
      disabled={disabled}
      aria-label="Close"
    >
      <X size={size} />
    </button>
  );
};

export default CloseButton;
